import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black py-12 border-t border-brand-magenta/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          
          {/* Logo Bölümü */}
          <div className="mb-8 md:mb-0 flex items-center gap-3">
            <img 
              src="/logo.png" 
              alt="ViralVantage Logo" 
              className="h-8 w-auto"
              onError={(e) => e.target.style.display='none'} 
            />
            <div className="flex flex-col">
              <span className="text-lg font-bold text-white tracking-tighter">VIRALVANTAGE</span>
              <span className="text-[9px] text-brand-magenta font-bold tracking-[0.2em] uppercase">Media</span>
            </div>
          </div>

          {/* Telif Hakkı */}
          <div className="text-gray-500 text-sm">
            © {new Date().getFullYear()} ViralVantage Media. All rights reserved.
          </div>

          {/* Sosyal Linkler veya Navigasyon (İsteğe bağlı) */}
          <div className="flex space-x-6 mt-6 md:mt-0">
            <a href="#portfolio" className="text-gray-400 hover:text-white transition-colors">Portfolio</a>
            <a href="#pricing" className="text-gray-400 hover:text-white transition-colors">Pricing</a>
            <a href="#contact" className="text-gray-400 hover:text-white transition-colors">Contact</a>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;